import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Mail, Users, Send, TrendingUp, History, Settings, MailOpen, LogOut, Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const Layout = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
  const navItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Kontrol Paneli' },
    { path: '/templates', icon: Mail, label: 'Şablonlar' },
    { path: '/recipients', icon: Users, label: 'Alıcılar' },
    { path: '/send', icon: Send, label: 'Kampanya Gönder' },
    { path: '/campaigns', icon: TrendingUp, label: 'Kampanya Raporları' },
    { path: '/replies', icon: MailOpen, label: 'Gelen Cevaplar' },
    { path: '/history', icon: History, label: 'Geçmiş' },
    { path: '/settings', icon: Settings, label: 'Ayarlar' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    toast.success('Çıkış yapıldı');
    navigate('/login');
  };

  return (
    <div className="flex min-h-screen bg-[#ffffff]">
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-white rounded-lg shadow-lg border border-[#e2e8f0]"
      >
        {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-30"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`fixed left-0 top-0 h-screen w-64 bg-[#f8fafc] border-r border-[#e2e8f0] flex flex-col z-40 transition-transform duration-300 ${
        isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
      } lg:translate-x-0`}>
        <div className="p-8 border-b border-[#e2e8f0]">
          <h1 className="text-2xl font-extrabold text-[#0f172a] tracking-tight">EmailPro</h1>
          <p className="text-sm text-[#64748b] mt-1">Pazarlama Paneli</p>
        </div>
        
        <nav className="flex-1 p-4 space-y-2">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => setIsSidebarOpen(false)}
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg font-medium transition-all duration-200 ${
                  isActive
                    ? 'bg-white text-[#6366f1] shadow-sm font-semibold'
                    : 'text-[#64748b] hover:text-[#0f172a] hover:bg-white/50'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <item.icon size={20} strokeWidth={isActive ? 2.5 : 1.5} />
                  <span>{item.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </nav>
        
        <div className="p-4 border-t border-[#e2e8f0] space-y-3">
          <div className="bg-white rounded-xl p-4 border border-[#e2e8f0]">
            <p className="text-xs font-medium text-[#64748b] mb-2">E-posta Servisi</p>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-[#10b981] animate-pulse"></div>
              <span className="text-sm font-medium text-[#0f172a]">Resend</span>
            </div>
          </div>
          
          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full justify-start gap-2 text-[#64748b] hover:text-red-600 hover:bg-red-50 hover:border-red-200"
          >
            <LogOut size={18} />
            Çıkış Yap
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 lg:ml-64 p-4 lg:p-8 pt-16 lg:pt-8">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;